var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "LoginCard",
    { attrs: { header: _vm.header } },
    [
      _c("h2", { class: _vm.$style.subheader }, [
        _vm._v("\n    " + _vm._s(_vm.subheader) + "\n  "),
      ]),
      _vm._v(" "),
      _c("p", { class: _vm.$style.error }, [
        _vm._v("\n    " + _vm._s(_vm.error) + "\n  "),
      ]),
      _vm._v(" "),
      _c("LoginActionButton", { attrs: { action: _vm.buttonProps.action } }, [
        _vm._v("\n    " + _vm._s(_vm.buttonProps.text) + "\n  "),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }